import styled from "styled-components";

export const PageBackground = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  background-color: ${(p) => p.theme.tokens.colors.bg};
`;

export const PageShell = styled.div`
  width: 100%;
  max-width: 480px;
  min-height: 100vh;
`;

export const Card = styled.div`
  background: ${(p) => p.theme.tokens.colors.surface};
  border-radius: ${(p) => p.theme.tokens.radii.lg}px;
  margin: 0 14px 14px;
  padding: 40px 24px;
  box-shadow: ${(p) => p.theme.tokens.shadows.card};
  border: 1px solid ${(p) => p.theme.tokens.colors.softBg};
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  font-family: ${(p) => p.theme.tokens.font.family};
`;

export const IconBadge = styled.div`
  width: 76px;
  height: 76px;
  border-radius: ${(p) => p.theme.tokens.radii.xl}px;
  background: ${(p) => p.theme.tokens.colors.softTeal};
  color: ${(p) => p.theme.tokens.colors.teal};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
`;

export const Message = styled.p`
  font-weight: 800;
  color: ${(p) => p.theme.tokens.colors.ink};
  font-size: 16px;
  margin: 0 0 20px;
`;
